import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import rootReducer from "../slices/rootReducer";

// ...

// Middlewares
const middleware = [logger];

export const store = configureStore({
  reducer: rootReducer,
  // middleware,
  devTools: process.env.NODE_ENV === "development",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export const RootState = store.getState;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export const AppDispatch = store.dispatch;
